/* global wpbp_app */
jQuery($ => {
    let $form = $('#password-lost');

    if ($form.length) {
        require.ensure(['parsleyjs/dist/parsley', 'parsleyjs/dist/i18n/de'], require => {
            require(['parsleyjs/dist/parsley', 'parsleyjs/dist/i18n/de']);
            $form.parsley()
                .on('form:submit', () => {
                    let $email = $form.find('[name="user_email"]'),
                        email = $email.val(),
                        $inputs = $email.add($form.find('.btn[type="submit"]')),
                        security = $form.find('#pwsec').val();

                    $inputs.prop('disabled', true);

                    $.post(wpbp_app.ajax_url, {
                        action: 'wpbp-password-lost',
                        user_email: email,
                        security
                    })
                    .then(() => {
                        $form.remove();

                        $('.success').html(`
                            <a class="link" href="${wpbp_app.passwordLost.loginUrl}">${wpbp_app.passwordLost.loginLinkLabel}</a>
                        `);
                    });

                    // prevent submission
                    return false;
                });
        }, 'password-lost');
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/lib/passwordLost.js